import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { DsInputComponent } from "./ds-input.component";

@NgModule({
  declarations: [DsInputComponent],
  imports: [CommonModule],
  exports: [DsInputComponent],
})
export class DsInputModule {}
